import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAllRatesRowData } from '../../../common/Qualification/QualificationActions';
import { RootState } from '../../../common/reducers';
import { PATH_DEBUG_SEARCH } from '../../../route/constants';
import { AppDispatch } from '../../../store';
import { SearchResult } from '../../SearchResult';
import ScenarioFooter from '../../Scenario/components/ScenarioFooter';
import { exitToLegacyDebug } from '../utils';

export const DebugResults: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const allRatesRowData = useSelector(
    (state: RootState) => state.EPPS?.allRatesRowData,
  );

  const footerProps = allRatesRowData
    ? {
        onCancel: () => dispatch(setAllRatesRowData(null)),
        cancelLabel: 'Back' as const,
      }
    : {
        onCancel: exitToLegacyDebug,
      };

  return (
    <>
      <SearchResult
        defaultTab="Classic"
        asEmbedded
        navigateOnError={() => navigate(PATH_DEBUG_SEARCH)}
      />
      <ScenarioFooter {...footerProps} />
    </>
  );
};

export default DebugResults;
